// extracted by mini-css-extract-plugin
export default {"container":"WhatWillYouGetBlock_container__Rbaur","title":"WhatWillYouGetBlock_title__WqyDk","list":"WhatWillYouGetBlock_list__UQpCk"};